
if(!window.hasOwnProperty('collectionGridBanners')){
  window.collectionGridBanners = []
}

// Wrap in IIFE to prevent "Identifier 'DOM' has already been declared" if script is loaded twice
(function() {
  'use strict';

  // Helper functions - Scoped locally to this IIFE
  const DOM = {
      qs: (selector) => document.querySelector(selector),
      qsa: (selector) => document.querySelectorAll(selector),
      docheight: () => Math.max(
          document.body.scrollHeight, document.documentElement.scrollHeight,
          document.body.offsetHeight, document.documentElement.offsetHeight,
          document.body.clientHeight, document.documentElement.clientHeight
      ),
      inview: (element, offset = 0) => {
          if (!element) return false;
          const rect = element.getBoundingClientRect();
          return (
              rect.top <= (window.innerHeight || document.documentElement.clientHeight) + offset &&
              rect.bottom >= -offset
          );
      }
  };

  // Client-Side Filtering & Pagination Logic
  // 1. Loads ALL products from collection.feed.liquid (paginated 250 at a time)
  // 2. Stores them in window.Collection.allProducts AND sessionStorage
  // 3. Filters locally based on Tags

  window.Collection = Object.assign(window.Collection || {}, {
    allProducts: [],      // Master list of all products in collection
    filteredProducts: [], // Current sub-list matching active filters
    products: [],         // Products currently visible (paginated)

    loader: {
      isLoading: false,
      isFetchingAll: false,
      loadedAll: false,

      // Infinite Scroll / Rendering Pointers
      currentPage: 1,      // Visual page index
      pageSize: 16,        // Products per visual batch
      renderedCount: 0,

      scrollListener: false
    },

    config: window.Collection.config || { page_size: 16, session_storage: true },

    // Storage Helper
    storage: {
        get: (key) => {
            if(!Collection.config.session_storage) return null;
            try {
                return JSON.parse(sessionStorage.getItem(key + ':' + window.location.pathname));
            } catch(e) { return null; }
        },
        set: (key, data) => {
            if(!Collection.config.session_storage) return;
            try {
                sessionStorage.setItem(key + ':' + window.location.pathname, JSON.stringify(data));
            } catch(e) { console.warn('Storage quota exceeded', e); }
        }
    },

    init: function() {

        // 1. Restore from Storage or Fetch All
        const cached = Collection.storage.get('all_products');

        if (cached && Array.isArray(cached) && cached.length > 0) {
            // Deduplicate cached data just in case
            const uniqueCached = [];
            const seenIds = new Set();
            cached.forEach(p => {
                if(!seenIds.has(p.id)){
                    seenIds.add(p.id);
                    uniqueCached.push(p);
                }
            });

            // console.log('DEBUG: Restored products from SessionStorage:', uniqueCached);
            Collection.allProducts = uniqueCached;
            Collection.loader.loadedAll = true;
            Collection.applyFilters(); // Apply filters immediately based on URL
        } else {
            console.log('DEBUG: No cache found. Starting fresh fetch of ALL products...');
            Collection.fetchAllProducts();
        }

        // Scroll Listener
        window.addEventListener('scroll', Collection.handleScroll);

        // Back/Forward Browser Buttons
        window.addEventListener('popstate', () => {
             Collection.applyFilters();
        });
    },

    // Recursively fetch all pages of the JSON feed
    fetchAllProducts: function(page = 1) {
        // If it's the first page, set the fetching flag
        if (page === 1) {
            Collection.loader.isFetchingAll = true;
            Collection.allProducts = []; // Reset master list
        }

        const nextLoader = DOM.qs('[data-next-products]');
        if(nextLoader) nextLoader.style.display = 'block';

        // Use 'collection.feed' view which now has 250 items per page
        const url = `${window.location.pathname}?view=feed&page=${page}&cache_buster=${Date.now()}`;
        console.log(`DEBUG: Fetching page ${page}...`, url);

        fetch(url)
            .then(res => res.json())
            .then(data => {
                if (!data.products) throw new Error('No products in feed');

                const newProducts = data.products;

                // Incrementally add to master list with deduplication
                const existingIds = new Set(Collection.allProducts.map(p => p.id));
                const uniqueNewProducts = newProducts.filter(p => !existingIds.has(p.id));

                if (uniqueNewProducts.length < newProducts.length) {
                    console.warn('DEBUG: Filtered out ' + (newProducts.length - uniqueNewProducts.length) + ' duplicate products.');
                }

                Collection.allProducts = Collection.allProducts.concat(uniqueNewProducts);
                console.log(`DEBUG: Page ${page} received ${newProducts.length} products. Total: ${Collection.allProducts.length}`);

                // IMMEDIATE RENDER:
                if (page === 1) {
                    // First batch: Full init (reset and render)
                    console.log('DEBUG: First batch received. Rendering immediately.');
                    Collection.applyFilters(false);
                } else {
                    // Subsequent batches: Update data silently in background
                    console.log('DEBUG: Background batch received. Updating list.');
                    Collection.applyFilters(true);
                }

                // Check pagination
                if (data.pagination && data.pagination.collection &&
                    data.pagination.collection.current_page < data.pagination.collection.pages) {
                    // Fetch next page
                    Collection.fetchAllProducts(page + 1);
                } else {
                    // DONE
                    console.log('DEBUG: All pages fetched. Final Total:', Collection.allProducts.length);
                    Collection.loader.loadedAll = true;
                    Collection.loader.isFetchingAll = false;

                    // Save to Storage ONLY when complete to ensure consistency
                    Collection.storage.set('all_products', Collection.allProducts);
                    console.log('DEBUG: >>> FULL JSON SAVED TO LOCALSTORAGE <<<');
                }
            })
            .catch(err => {
                console.error('DEBUG: Error fetching products', err);
                Collection.loader.isFetchingAll = false;
            });
    },

    // The Core Logic: Filter 'allProducts' -> 'filteredProducts'
    applyFilters: function(isBackgroundUpdate = false) {
        // 1. Parse Filters from URL
        const params = new URLSearchParams(window.location.search);
        const activeFilters = {};

        params.forEach((val, key) => {
            if (key.startsWith('filter[')) {
                const filterName = key.replace('filter[', '').replace(']', '').trim();
                activeFilters[filterName] = val.split(',').map(v => decodeURIComponent(v).trim());
            }
        });

        // 2. Filter Logic
        let newFiltered = [];
        if (Object.keys(activeFilters).length === 0) {
            newFiltered = Collection.allProducts;
        } else {
            newFiltered = Collection.allProducts.filter(product => {
                return Object.keys(activeFilters).every(filterKey => {
                    const requiredValues = activeFilters[filterKey];
                    return requiredValues.some(reqVal => {
                         return product.tags.some(tag => {
                             const t = tag.toLowerCase();
                             const v = reqVal.toLowerCase();
                             
                             let prefixMatch = true;
                             if (t.includes(':')) {
                                   const tagPrefix = t.split(':')[0].trim().toLowerCase().replace(/ /g, '_').replace(/-/g, '_');
                                   const expectedPrefix = filterKey.toLowerCase().replace(/ /g, '_').replace(/-/g, '_');
                                   
                                   if (tagPrefix !== expectedPrefix && !expectedPrefix.includes(tagPrefix) && !tagPrefix.includes(expectedPrefix)) {
                                       prefixMatch = false; 
                                   }
                             }
                             
                             if (!prefixMatch) return false;
                             
                             return t === v || t.endsWith(`:${v}`) || t.includes(` ${v}`)
                                    || t === v;
                         });
                    });
                });
            });
        }

        Collection.filteredProducts = newFiltered;
        // console.log('DEBUG: Filtered Results:', Collection.filteredProducts);

        // 3. Render Handling
        if (isBackgroundUpdate) {
            // If the user hasn't scrolled much or there are few products, we might want to ensure the grid is filled
            // But generally, we just let infinite scroll handle rendering more when the user scrolls.
            // Exception: If we had 0 results before and now we have results, we should try to render.
            if (Collection.loader.renderedCount === 0 && Collection.filteredProducts.length > 0) {
                 Collection.render('append');
            } else if (Collection.loader.renderedCount < Collection.pageSize && Collection.filteredProducts.length > Collection.loader.renderedCount) {
                // If we haven't even filled the first page yet, add more.
                 Collection.render('append');
            }
            // else: Do nothing visible, just wait for scroll.
        } else {
            // Standard reset (First load or Filter change)
            Collection.resetPagination();
            Collection.render();
        }
    },

    // Reset view to top
    reset: function() {
        // Called by outside scripts (facets-sidebar).
        // Since we handle state via URL, we just re-apply filters from the new URL.
        Collection.applyFilters();
    },

    // Actually just re-runs the filter logic based on current URL
    load: function() {
         Collection.applyFilters();
    },

    resetPagination: function() {
        Collection.loader.currentPage = 1;
        Collection.loader.renderedCount = 0;
        Collection.products = []; // clear visual list

        const container = DOM.qs('.collection-products');
        if (container) container.innerHTML = '';

        window.scrollTo(0,0);
    },

    render: function(method = 'append') {
        const container = DOM.qs('.collection-products');
        const emptyMsg = DOM.qs('[data-empty-products]');
        const nextLoader = DOM.qs('[data-next-products]');

        // Slice the next batch from filteredProducts
        const start = Collection.loader.renderedCount;
        const end = start + Collection.loader.pageSize;

        const batch = Collection.filteredProducts.slice(start, end);

        if (batch.length === 0 && start === 0) {
            // No results at all
            if (emptyMsg) emptyMsg.style.display = 'block';
            if (nextLoader) nextLoader.style.display = 'none';
            return;
        } else {
             if (emptyMsg) emptyMsg.style.display = 'none';
        }

        // Generate HTML
        const html = batch.map(product => {
             if (window.ProductRenderer) {
                 return window.ProductRenderer.render(product, Collection.config);
             }
             return '';
        }).join('');

        if (method === 'prepend') {
             // Not really used in this simplified infinite scroll down only
             container.insertAdjacentHTML('afterbegin', html);
        } else {
             container.insertAdjacentHTML('beforeend', html);
        }

        Collection.loader.renderedCount += batch.length;

        // Manage Loader Visibility
        if (Collection.loader.renderedCount >= Collection.filteredProducts.length) {
            if(nextLoader) nextLoader.style.display = 'none';
        } else {
            if(nextLoader) nextLoader.style.display = 'block';
        }

        Collection.loader.scrollListener = true;
        Collection.loader.isLoading = false;
    },

    handleScroll: function() {
         if (!Collection.loader.scrollListener || Collection.loader.isLoading) return;

         const nextLoader = DOM.qs('[data-next-products]');
         const preloaderScrollOffset = 300;

         if (nextLoader && DOM.inview(nextLoader, preloaderScrollOffset)) {
             // Check if we have more products in filtered text to show
             if (Collection.loader.renderedCount < Collection.filteredProducts.length) {
                  Collection.loader.isLoading = true;
                  // distinct from 'fetching from server', this is just rendering next batch from memory
                  console.log('DEBUG: Infinite Scroll - Rendering next batch...');
                  setTimeout(() => { // small artificial delay for UX (optional) or just run
                      Collection.render('append');
                  }, 100);
             }
         }
    }

  });

  // Initialize on DOM Ready
  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', Collection.init);
  } else {
      Collection.init();
  }


})(); // End IIFE
